import React from "react";
import { css } from "emotion";
import { textSizes, colors, boxStyles } from "../../styles/theme";

const Section = ({ heading, children }) => {
  return (
    <div className={section}>
      {heading && <h4>{heading}</h4>}
      <div>{children}</div>
    </div>
  );
};

export default Section;

const section = css`
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  max-width: 500px;
  width: 100%;
  h4 {
    font-size: ${textSizes.normal};
    color: ${colors.titleColor};
    padding-bottom: 10px;
    letter-spacing: 1px;
  }
  div {
    width: 100%;
  }
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    h4 {
      padding-bottom: 10px;
      letter-spacing: 1px;
    }
  }
`;
